import { atom } from "jotai";
import { IEproForm } from "../types/IEproForm";

export const eproformAtom = atom<IEproForm | null>(null);
